import { render } from "./Money.vue?vue&type=template&id=24e656ce&ts=true&lang=pug"
import script from "./Money.vue?vue&type=script&lang=ts"
export * from "./Money.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/CarrefourOneAPP/website/game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__